import { Injectable, NgZone } from '@angular/core';
import { Subject }    from 'rxjs/Subject';

@Injectable()
export class NotificationContainer {
    isError = false;
    message = '';
}

@Injectable()
export class NotificationServiceBus {

  constructor(private ngZone: NgZone) {}

    // Observable string sources
    launchNotificationSource = new Subject<NotificationContainer>();
    // Observable string streams
    launchNotification$ = this.launchNotificationSource.asObservable();
    // Handle error objects for Notification
    handleErrorObjectsForNotification(obj) {
        let message = '';
        for (let field in obj.errors) {
            if (obj.errors.hasOwnProperty(field)) {
                let fieldName = field === 'base' ? '' : field.charAt(0).toUpperCase() + field.slice(1);
                message += `${fieldName} ${obj.errors[field][0]}. `;
            }
        }
        this.launchNotification(true, message);
    }
    // Service message commands
    launchNotification(isError: boolean, message: string | object) {
      this.ngZone.runOutsideAngular(() => {
        let notificationContainer = new NotificationContainer();
        if (typeof message === 'string') {
            notificationContainer.message = message;
        } else if (message.hasOwnProperty('errors') && message['errors'].length) {
            notificationContainer.message = message['errors'];
        } else if (message.hasOwnProperty('error') && message['error'].length) {
            notificationContainer.message = message['error'];
        } else if (typeof message === 'object' && isError) {
            this.handleErrorObjectsForNotification(message);
        } else {
            notificationContainer.message = JSON.stringify(message).replace(/[{"\[\]\}:]|errors||error|base/gmi, '');
        }
        notificationContainer.isError = isError;
        this.launchNotificationSource.next(notificationContainer);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/notification/notification.service.ts